import React, { useMemo, useState } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import NameWithIcon from './NameWithIcon/NameWithIcon';
import { TriangleSlider } from '../../slider';

interface CriteriaSectionProps {
  criteriaFields: any[];
  onSliderChange: (value: number, id: string) => void;
  onAutoPopupCheck: (value: number, id: string) => void;
  openCriteriaSettings: (id: string) => void;
  getFieldName: (name: string) => string;
}

const CriteriaSection: React.FC<CriteriaSectionProps> = ({
  criteriaFields,
  onSliderChange,
  onAutoPopupCheck,
  openCriteriaSettings,
  getFieldName,
}) => {
  const [showAll, setShowAll] = useState(false);

  const importanceById = useMemo(
    () =>
      Object.fromEntries(
        criteriaFields.map(c => [c.id, c.importance])
      ),
    [criteriaFields]
  );

  const topCriteria = criteriaFields.filter(c => c.display_on_top);
  const hiddenCriteria = criteriaFields.filter(c => !c.display_on_top);

  const renderCriteria = (criteria: any[]) =>
    criteria.map(({ id, name, hide_importance, hide_field, icon, importance }) => {
    const criteriaName = getFieldName(name);

    return (
      <div key={id} className={`app-criteria-field ${hide_importance ? 'hidden' : ''}`}>
        <label>
          <NameWithIcon icon={icon} name={criteriaName} />
          <TriangleSlider
            name={id}
            min={0}
            max={100}
            step={1}
            value={Number(importanceById[id] ?? 0)}
            onChange={(_, value) => onSliderChange(value as number, id)}
            onChangeCommitted={(_, value) =>
              onAutoPopupCheck(value as number, id)
            }
            isEditable
            isEditingDisabled={hide_field}
            onEditIconClick={() => openCriteriaSettings(id)}
          />
        </label>
      </div>
    );
  });
  return (
    <div className="criteria-section">
      {renderCriteria(topCriteria)}

      {showAll && renderCriteria(hiddenCriteria)}

      {hiddenCriteria.length > 0 && (
        <button
          className={`show-more-btn ${showAll ? 'rotated' : ''}`}
          onClick={() => setShowAll(prev => !prev)}
        >
          <KeyboardArrowDownIcon />
        </button>
      )}
    </div>
  );
};

export default CriteriaSection;